import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { useSelector } from 'react-redux';

import Icon from '../../../../icons/Icon';

import scss from './RecreateFilters.module.scss';

function AttemptsCount() {
  const { t } = useTranslation('demoAdImages');

  const attempts = useSelector((state) => state.demoRecreate.attempts);

  return (
    <div className={scss.attemptsCount}>
      <Icon icon={ErrorOutlineRoundedIcon} disableCommonColors disableCommonStyles />
      {t('attemptsLeft', { number: attempts })}
    </div>
  );
}

export default AttemptsCount;
